import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Icon,
  Header,
  Form,
  Loader,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { requestActions } from '../../actions/request.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { dateTimeFormat } from '../../helpers/timeFormat';
import { getStatusLabel, getTypeLabel } from '../../helpers/request';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class RequestAllReportScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        approver: null,
        department: null,
        period: ''
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const monthStart = moment().startOf('month').format(DATE_FORMAT);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${monthStart} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleApproverChange(approver) {
    this.setState({ approver, page: 1 });
    this.handleSearchDebounced();
  }

  handleDepartmentChange(department) {
    this.setState({ department, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, approver, department, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(requestActions.fetch({ page, approver, department, startDate, endDate, orderBy: "Id", export: isExport ? true : null, ascending: false }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Solicitações</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group widths={4}>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Usuário' onChange={(e, data) => this.handleApproverChange(data.value)} loading={loading} />
            <Form.Input icon='search' label='Gestor' onChange={(e, data) => this.handleApproverChange(data.value)} loading={loading} />
            <Form.Input icon='search' label='Departamento' onChange={(e, data) => this.handleDepartmentChange(data.value)} loading={loading} />
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'><Icon name='file excel' /> Exportar</Form.Button>
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Tipo</Table.HeaderCell>
                    <Table.HeaderCell>Usuário</Table.HeaderCell>
                    <Table.HeaderCell>E-Mail</Table.HeaderCell>
                    <Table.HeaderCell>Gestor</Table.HeaderCell>
                    <Table.HeaderCell>Data</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Tempo</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                { registers && registers.Results.map((register) => {
                    return <Table.Row key={register.id}>                        
                        <Table.Cell>{register.Id}</Table.Cell>
                        <Table.Cell>{getTypeLabel(register.Type)}</Table.Cell>
                        <Table.Cell>{register.Requester.Name}</Table.Cell>
                        <Table.Cell>{register.Requester.Email}</Table.Cell>
                        <Table.Cell>{register.Approver && register.Approver.Name}</Table.Cell>
                        <Table.Cell>{dateTimeFormat(register.StartDate)}</Table.Cell>
                        <Table.Cell>{getStatusLabel(register.Status)}</Table.Cell>
                        <Table.Cell>{moment.duration(register.MinutesAmount, "minutes").format("HH:mm", { trim: false })}</Table.Cell>
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { requests } = state;    
  return {
     registers: requests || null,
     loading: requests.loading
  };
}

const connectedReportScreen = connect(mapStateToProps)(RequestAllReportScreen);
export { connectedReportScreen as RequestAllReportScreen };
